<template>
  <span v-if="alarmCount > 0" :class="{ flash: hasNewAlarm, 'notifications-badge error': positionAbsolute, 'badge badge-pill badge-danger': !positionAbsolute }">
    {{ alarmCount }}
  </span>

  <span v-else-if="alarmCount === 0" :class="{ 'notifications-badge success': positionAbsolute, 'badge badge-pill badge-success': !positionAbsolute }">
    0
  </span>

  <span v-else :class="{ 'notifications-badge gray': positionAbsolute, 'badge badge-pill badge-light': !positionAbsolute }">
    -
  </span>
</template>

<script>
export default {
  props: {
    // Number to display
    alarmCount: {
      type: Number,
      required: true
    },
    // Position of the badge: absolute in navbar for instance
    positionAbsolute: {
      type: Boolean,
      default: false
    }
  },

  data: () => {
    return {
      previousAlarmCount: null
    }
  },

  computed: {
    hasNewAlarm () {
      return this.alarmCount > this.previousAlarmCount
    }
  },

  updated: function () {
    // Let the animation run and set the previous counts
    setTimeout(() => {
      this.previousAlarmCount = this.alarmCount
    }, 1000)
  }
}
</script>

<style scoped lang="scss">
  @import "~@/scss/variables";

  .notifications-badge {
    right: 5px;
  }

  // Flash animation
  .flash {
    animation-name: flash;
    animation-duration: 1s;
    animation-fill-mode: both;
  }

  @keyframes flash {
    50%,
    from,
    to {
      opacity: 1;
    }

    25%,
    75% {
      opacity: 0;
    }
  }
</style>
